import { render, staticRenderFns } from "./TablePurchaseOrderIndex.vue?vue&type=template&id=585bd684&scoped=true&"
import script from "./TablePurchaseOrderIndex.vue?vue&type=script&lang=js&"
export * from "./TablePurchaseOrderIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585bd684",
  null
  
)

export default component.exports